<div class="d-flex flex-column justify-content-center align-items-center text-center">
  <h1
    class="display-1 fw-bold"
    i18n="heading|Numeric error code for a 403 Forbidden page@@forbiddenTitle"
  >
    403
  </h1>
  <p class="fs-3">
    <span
      class="text-danger"
      i18n="exclamation|Short expression of surprise on a 403 error page@@forbiddenOops"
      >Oops!</span
    >
    <span i18n="error message|Brief description of the 403 forbidden error@@forbiddenMessage"
      >Access not allowed.</span
    >
  </p>
  <p
    class="lead"
    i18n="
      explanatory text|Detailed message explaining the 403 error on the forbidden
      page@@forbiddenLead"
  >
    You don't have permission to view this page. This may be due to declining consent for the
    application.
  </p>
  <a
    href=""
    class="btn btn-outline-primary"
    i18n="
      button label|Call-to-action button text to navigate back to the homepage from a 403 error
      page@@forbiddenGoHomeButton"
    >Go Home</a
  >
</div>
